import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  makeStyles,
} from "@fluentui/react-components";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { useEffect, useState } from "react";
import moment from "moment";

const useStyles = makeStyles({
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  widthcontent: {
    width: "520px",
  },
  btnWrapper: {
    margin: "10px 0",
  },
  dialogTitle: {
    fontSize: "16px",
    fontWeight: 600,
    textAlign: "left",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
});

interface SavePopupProps {
  confirmsavepopup: boolean;
  distributedAmount?: string;
  targetedAmount?: string;
  difference?: string;
  setConfirmsavepopup: (open: boolean) => void;
  onSave: (data: { receipted_date: any; description?: string }) => void;
  saveError?: string;
  action?: string;
  saveLoading?: boolean;
}

const SavePopup = (props: SavePopupProps) => {
  const styles = useStyles();
  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const [confirmCancelDistribution, setConfirmCancelDistribution] =
    useState(false);
  const [confirmCancelDistributionPopup, setConfirmCancelDistributionPopup] =
    useState(false);

  useEffect(() => {
    if (confirmCancelDistribution) {
      props.setConfirmsavepopup(false);
      setSelectedDate(new Date());
      setConfirmCancelDistribution(false);
    }
  }, [confirmCancelDistribution]);

  const onSelectDate = (date: Date | null) => {
    setSelectedDate(date);
  };

  const onFormatDate = (date?: Date): string => {
    return !date ? "" : moment(date).format("DD-MM-YYYY");
  };

  const handleSave = async () => {
    const formattedDate = moment(selectedDate).utc();
    try {
      const success: any = await props.onSave({
        receipted_date: formattedDate,
      });
      return success;
    } catch (error: any) {
      alert(error.message);
    }
  };

  const handleCancelClick = () => {
    setConfirmCancelDistributionPopup(true);
  };

  const handleConfirmCancel = () => {
    setConfirmCancelDistribution(true);
    setConfirmCancelDistributionPopup(false);
  };

  const handleCloseCancelPopup = () => {
    setConfirmCancelDistributionPopup(false);
  };

  return (
    <>
      {/* Main Save Popup */}
      <Dialog open={props.confirmsavepopup}>
        <DialogSurface className={styles.widthcontent}>
          <DialogTitle className={styles.dialogTitle}>
            Distribution Payment Date
          </DialogTitle>

          <DialogBody className={styles.content}>
            {props.saveError && (
              <p style={{ color: "red", fontSize: "14px" }}>
                {props.saveError}
              </p>
            )}

            <p>
              Please enter a date when the distributions will be paid and click
              the Save button.
            </p>

            <p>Click to cancel the distribution.</p>

            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "8px",
              }}
            >
              <label>Payment Date:</label>
              <DatePicker
                placeholder="Select date"
                allowTextInput={true}
                value={selectedDate}
                onSelectDate={() => onSelectDate}
                formatDate={onFormatDate}
                // minDate={}
                // maxDate={new Date()}
              />
            </div>
          </DialogBody>

          <DialogActions className={styles.btnWrapper}>
            <Button
              appearance="secondary"
              onClick={handleSave}
              disabled={props?.saveLoading}
            >
              {props?.saveLoading ? "Saving..." : "Save"}
            </Button>

            <Button
              appearance="primary"
              className="asc-button-primary"
              onClick={handleCancelClick}
            >
              Cancel
            </Button>
          </DialogActions>
        </DialogSurface>
      </Dialog>

      {/* Cancel Distribution Confirmation Popup */}
      <Dialog open={confirmCancelDistributionPopup}>
        <DialogSurface>
          <DialogBody>
            <DialogTitle>Confirm Cancellation</DialogTitle>
            <DialogContent>
              <p>Do you wish to cancel the Distribution?</p>
            </DialogContent>
            <DialogActions>
              <Button
                appearance="primary"
                className="asc-button-primary"
                onClick={handleConfirmCancel}
              >
                Yes
              </Button>
              <Button appearance="secondary" onClick={handleCloseCancelPopup}>
                No
              </Button>
            </DialogActions>
          </DialogBody>
        </DialogSurface>
      </Dialog>
    </>
  );
};

export default SavePopup;
